import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class EmailService extends BaseService {
  protected constructor(protected httpService: HttpService) {
    super('Email', httpService);
  }

  emailReport(to: string, pdfOutput: string): Observable<any> {
    return this.httpService.postForText(`${this.apiUrl}/EmailReport/${encodeURIComponent(to)}`, pdfOutput);
  }

  emailReportWithSellingCompany(
    email: string,
    ccEmail: string,
    subject: string,
    emailBody: string,
    pdfOutput: string,
    sellingCompany: string,
    attachDocuments: boolean,
    type: string,
    key: string,
  ): Observable<any> {
    return this.httpService.postForText(
      `${this.apiUrl}/EmailReportWithSellingCompany/${encodeURIComponent(email)}/${encodeURIComponent(ccEmail ?? ' ',)}/${encodeURIComponent(subject)}/${btoa(unescape(encodeURIComponent(emailBody)))}/${attachDocuments}/${type}/${key}/${sellingCompany}`,
      pdfOutput,
    );
  }
}
